import script from "./UpcomingDrawsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingDrawsView.vue?vue&type=script&setup=true&lang=ts"

import "./UpcomingDrawsView.vue?vue&type=style&index=0&id=fd3beaf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd3beaf4"]])

export default __exports__